import { render } from "./foto-15.vue?vue&type=template&id=4dc441fa&scoped=true"
import script from "./foto-15.vue?vue&type=script&lang=js"
export * from "./foto-15.vue?vue&type=script&lang=js"

import "./foto-15.vue?vue&type=style&index=0&id=4dc441fa&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc441fa"]])

export default __exports__